module.exports = __webpack_public_path__ + "img/30.13e5dcd2.jpg";